import clsx from 'clsx';
import React from 'react';

import Container, { ContainerProps } from '@material-ui/core/Container';

import { useStyles } from './styles';

type ContainerClasses = ContainerProps['classes'];

export type ComponentProps = {
	children: React.ReactNode;
	containerClasses?: ContainerClasses;
};

const ShowroomContainerLayout = (props: ComponentProps) => {
	const { children, containerClasses } = props;
	const classes = useStyles();

	const computedClasses: ContainerClasses = React.useMemo(
		() => ({
			...containerClasses,
			root: clsx(classes.container, containerClasses?.root)
		}),
		[containerClasses, classes]
	);

	return <Container classes={computedClasses}>{children}</Container>;
};

export default React.memo(ShowroomContainerLayout);
